import { userService } from "../services";
import config from "../config/config";

export const UserAction = {
  fetchUserList,
  saveUser,
  fetchById,
  userActiveInactive,
  updateUser,
  fetchUserListDropDown,
};

async function fetchUserList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.UserList}?companyId=${
      payload.companyId
    }&pageSize=${payload.pageSize}&pageNo=${payload.pageNo}&employeeCode=${
      payload.employeeCode
    }&siteId=${payload.siteId}&keyWord=${payload?.name}&designation=${
      payload.designationId ? payload.designationId : ""
    }&isActive=${payload.isActive}`;
    // &roleId=${payload.roleId}`;
    // &pageSize=${payload.pageSize}&pageNo=${payload.pageNo}
    debugger;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchUserListDropDown(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.userList}?companyId=${
      payload.companyId
    }&pageSize=${payload.pageSize}&pageNo=${payload.pageNo}&employeeCode=${
      payload.employeeCode
    }&siteId=${payload.siteId}&keyWord=${payload?.name}&designation=${
      payload.designationId ? payload.designationId : ""
    }&isActive=${payload.isActive}`;
    // &pageSize=${payload.pageSize}&pageNo=${payload.pageNo}
    debugger;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function updateUser(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.UpdateUser}`;
    let data = new FormData();
    data.append("name", payload.name);
    data.append("gender", payload.gender);
    data.append("id", payload.id);
    data.append("phoneNumber", payload.phoneNumber);
    data.append("designation", payload.designation);
    data.append("address", payload.address);
    data.append("updatedBy", payload.updatedBy);
    data.append("company", payload.company);
    // data.append("file", payload.file);
    data.append("isActive", payload.isActive);
    data.append("lastName", payload.lastName);
    data.append("image", payload.image);

    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveUser(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.AddUser}`;
    let data = new FormData();

    data.append("name", payload.name);
    data.append("employeeCode", payload.employeeCode);
    data.append("gender", payload.gender);
    data.append("email", payload.email);
    data.append("phoneNumber", payload.phoneNumber);
    data.append("designation", payload.designation);
    data.append("address", payload.address);
    data.append("createdBy", payload.createdBy);
    data.append("company", payload.company);
    // data.append("file", payload.file);
    data.append("isActive", payload.isActive);
    data.append("lastName", payload.lastName);
    data.append("image", payload.image);

    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function userActiveInactive(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.ActiveUser}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      showSnackbar(response.data.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchById(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.GetUserById}?id=${payload.userId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
